import axiosInstance from "./axiosInstance";

const storePricesService = {
  getAppStoreStatus: async (params = {}) =>
    (await axiosInstance.get("/admin/store-prices/app-store/status", { params })).data,

  listAppStoreProducts: async (params = {}) =>
    (await axiosInstance.get("/admin/store-prices/app-store/products", { params })).data,

  getAppStorePrices: async (productId, params = {}) =>
    (
      await axiosInstance.get(
        `/admin/store-prices/app-store/products/${encodeURIComponent(productId)}/prices`,
        { params }
      )
    ).data,

  getPlayStoreStatus: async (params = {}) =>
    (await axiosInstance.get("/admin/store-prices/play-store/status", { params })).data,

  listPlayStoreProducts: async (params = {}) =>
    (await axiosInstance.get("/admin/store-prices/play-store/products", { params })).data,

  getPlayStorePrices: async (productId, params = {}) =>
    (
      await axiosInstance.get(
        `/admin/store-prices/play-store/products/${encodeURIComponent(productId)}/prices`,
        { params }
      )
    ).data,
};

export default storePricesService;
